import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '@/entities';
import { DEFAULT_LANGUAGE_CODE } from './constants';

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: DEFAULT_LANGUAGE_CODE, // default language
    fallbackLng: 'ru',
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    supportedLngs: SUPPORTED_LANGUAGES.map((lang) => lang.code),
    ns: [
      'common',
      'orders',
      'basket',
      'errors',
      'catalog',
      'payment',
      'address',
      'documents',
      'validation',
      'promocodes',
      'aboutRestaurant',
      'auth',
    ],
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
  });

export default i18n;

// Helper function to set HTML dir attribute for RTL support
export const setDocumentDirection = (language: string) => {
  document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
};
